import { AccountStatusMessage } from "@/components/AccountStatusMessage";
import { AccountStatusResponse } from "@/helpers";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { useRouter } from "next/navigation";
import { FC, PropsWithChildren } from "react";

type AccountStatusMessageBlockProps = Pick<BuilderProps, "builderContext"> & {
  onFinish: (accountStatus: AccountStatusResponse, router: unknown) => void;
};
export const AccountStatusMessageBlock: FC<
  PropsWithChildren<AccountStatusMessageBlockProps>
> = ({ children, onFinish }) => {
  const router = useRouter();

  const onRequestFinish = (accountStatus: AccountStatusResponse) => {
    onFinish(accountStatus, router);
  };
  return (
    <AccountStatusMessage onFinish={onRequestFinish}>
      {children}
    </AccountStatusMessage>
  );
};
